import { enStatus } from 'interface/course';
import { IShowcaseCourse } from 'interface/showcase';
import Default from './Default';
import CourseStatus from './CourseStatus';
import CourseFooter from './CourseFooter';
import { Typography } from '@material-ui/core';
import { useState } from 'react';
import BackdropStatus from './BackdropStatus';
import MobileModal from './MobileModal';
import PreviewContainer from '../../../Carousel/Preview';
import Card from '../../Card';
import { v4 } from 'uuid';
import useImageFallback from 'hooks/useImageFallback';
import { useHistory } from 'react-router';
import { sendElastic } from 'actionCreators/judasLog';
import { slugify } from 'utils';
interface IProps {
  course: IShowcaseCourse;
}

const CourseCard = (props: IProps) => {
  const [showDetails, setShowDetails] = useState(false);
  const history = useHistory();
  const imageProps = useImageFallback(
    props.course.image ?? props.course.old_image,
    require(`assets/img/nutror-card-${props.course.id % 5}.png`)
  );
  const disableClick = [enStatus.EXPIRED, enStatus.NOT_RELEASED].includes(props.course.status);

  const openCourse = () => {
    sendElastic('clickCourse', `Clicou no curso: ${props.course.title}`, {
      courseHash: props.course.hash,
      courseId: props.course.id,
    });
    history.push(`/curso/${props.course.hash}/${props.course.slug || slugify(props.course.title)}`);
  };

  const openLesson = () => {
    history.push(
      `/curso/${props.course.hash}/${props.course.slug || slugify(props.course.title)}/aula/${props.course.lesson_id}`
    );
  };

  const handleOpenCourseOrLesson = () => {
    if (disableClick) {
      return;
    }

    if (props.course.lesson_id) {
      return openLesson();
    }

    return openCourse();
  };

  const isNewCourse = () => {
    if ([enStatus.EXPIRED, enStatus.BLOCKED].includes(props.course.status)) {
      return false;
    }
    return props.course.new_content;
  };

  const renderContent = () => {
    const status = [enStatus.EXPIRED, enStatus.BLOCKED, enStatus.NOT_RELEASED];
    if (status.includes(props.course.status)) {
      return <CourseStatus course={props.course} isNewCourse={isNewCourse()} />;
    }
    return <Default course={props.course} isNewCourse={isNewCourse()} onClick={handleOpenCourseOrLesson} />;
  };

  const toggleModal = () => {
    setShowDetails((isOpen) => !isOpen);
  };

  const uuid = v4();

  const defaultProps = {
    title: props.course.title,
    id: props.course.id,
    ...imageProps,
    style: { cursor: disableClick ? 'inherit' : 'pointer' },
    onClick: handleOpenCourseOrLesson,
    backdrop: <BackdropStatus course={props.course} isNewCourse={isNewCourse()} />,
  };

  return (
    <>
      <PreviewContainer.Iddle onClick={handleOpenCourseOrLesson} onTouch={toggleModal} id={uuid}>
        <Card {...defaultProps} />
      </PreviewContainer.Iddle>
      <PreviewContainer.Active id={uuid}>
        <Card {...defaultProps}>
          {renderContent()}
          <Typography variant='body1' component='span'>
            {props.course.title}
          </Typography>
          <CourseFooter course={props.course} isNewCourse={isNewCourse()} />
        </Card>
      </PreviewContainer.Active>
      <MobileModal open={showDetails} onClose={toggleModal} course={props.course} isNewCourse={isNewCourse()}>
        {renderContent()}
      </MobileModal>
    </>
  );
};

export default CourseCard;
